<template>
  <div class="label-view">
    <div class="line"></div>
    <div class="title">{{ title }}</div>
    <div class="text" v-if="count > 0">待完成{{ count }}条</div>
    <div class="whole-view" v-if="showAll" @click="goDetails">
      全部
      <img class="whole-img" src="../assets/images/person/right.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    showAll: {
      type: Boolean,
      default: true
    },
    count: {
      type: Number,
      default: 0
    }
  },
  methods: {
    goDetails() {
      this.$emit('goToDetails')
    }
  }
}
</script>

<style lang="less" scoped>
.label-view {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  position: relative;
  .line {
    width: 4px;
    height: 12px;
    background: #EB1700;
    border-radius: 2px;
    margin-right: 5px;
  }
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #1f333f;
  }
  .text {
    padding: 3px 6px;
    min-width: 69px;
    text-align: center;
    font-size: 12px;
    margin-left: 8px;
    background: rgba(255, 0, 0, 0.08);
    border: 1px solid #ff0000;
    border-radius: 5px;
    color: #ff0000;
  }
  .whole-view {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    font-size: 11px;
    font-weight: 500;
    color: #666666;
    .whole-img {
      width: 13px;
      height: 13px;
      margin-left: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TitleBar.vue